import { fetchMe, fetchUserSettingsCloud, putUserSettingsCloud } from "./api/client";
import { isApiConfigured } from "./api/config";
import { applyUserSettingsFromCloud, loadUserSettings } from "./user-settings";

export type SettingsCloudAuth = {
  isAuthenticated: boolean;
  isLoading: boolean;
  ensureApiSession: () => Promise<void>;
};

/**
 * After subscription sync: if the account has no saved settings row, upload this device’s local
 * preferences; otherwise replace local state with the server copy (same “remote wins” idea as the
 * subscription list once data exists in the cloud).
 */
export async function syncUserSettingsWithCloudIfLinked(
  auth: SettingsCloudAuth,
): Promise<void> {
  if (!isApiConfigured()) return;
  if (!auth.isAuthenticated || auth.isLoading) return;
  await auth.ensureApiSession();
  const me = await fetchMe();
  if (!me) return;

  let remote: Awaited<ReturnType<typeof fetchUserSettingsCloud>>;
  try {
    remote = await fetchUserSettingsCloud();
  } catch {
    return;
  }

  const local = loadUserSettings();

  if (remote === null) {
    try {
      await putUserSettingsCloud(local);
    } catch {
      /* keep local only */
    }
  } else {
    applyUserSettingsFromCloud(remote);
  }
}
